import { SubscriptionCheck } from "../../../../components/Access/helper/subscription/SubscriptionCheck";
import { SubscriptionScopeKey } from "../../../../components/Access/helper/subscription/enum/SubscriptionScopeKey";
import { RowType } from "../../../../components/Editable/FormItem/Rows/RowType";
import { processItemsRemoval } from "./processItemsRemoval";

/**
 * Remove non-base uom items from form items / stock items if user does not have UOM subscription
 */
export const processItemsMultiUom = ({
    items = [],
    productList,
    // processMode = 'remove', // to remove line; or 'base' to replace with base uom
}) => {
    const shouldRemoveUomLineChecker = (item, product) => {
        const baseUom = product?.units?.find(u => u.is_base);
        const shouldRemoveItem = (item.product_unit_id && baseUom?.id !== item.product_unit_id);
        return shouldRemoveItem;
    };

    const processedItems = processItemsRemoval({
        items,
        productList,
        subscriptionScopeKey: SubscriptionScopeKey["PRODUCT.MULTI_UOM"],
        checkShouldRemoveItem: shouldRemoveUomLineChecker,
    });

    return {
        newItems: processedItems.newItems,
        removedItems: processedItems.removedItems,
    };
};

/**
 * Check for subscription for other Multi series features, eg Tax, Location.
 * Replace unsubscribed features with default values or remove them.
 */
export const processItemsMultiOther = ({
    items = [],
    settings,
}) => {
    const hasMultiLocationSubscription =
        SubscriptionCheck.withKeys(SubscriptionScopeKey['INVENTORY.MULTI_LOCATION']).hasSubscriptionTo();

    const hasTaxSubscription =
        SubscriptionCheck.withKeys(SubscriptionScopeKey['TAX.SST']).hasSubscriptionTo();

    const arr = [];
    let hasTaxChange = false;
    let hasLocationChange = false;

    items.forEach(item => {
        const newItem = {...item};
        if (!hasMultiLocationSubscription && item.location_id &&
            item.location_id !== settings.default_location_id
        ) {
            newItem.location_id = settings.default_location_id;
            newItem.location_code = undefined;

            if (!hasLocationChange)
                hasLocationChange = true;
        }

        if (!hasTaxSubscription && item.tax_code_id) {
            newItem.tax_code = undefined;
            newItem.tax_code_id = undefined;
            newItem.tax_amount = undefined;

            if (!hasTaxChange)
                hasTaxChange = true;
        }

        if (item.type === RowType.bundle) {
            const {
                newItems: newChildren,
                hasLocationChange: hasLocationChangeBundle,
                hasTaxChange: hasTaxChangeBundle,
            } = processItemsMultiOther({
                items: newItem.children,
                settings,
            });

            if (!hasTaxChange && hasTaxChangeBundle)
                hasTaxChange = true;

            if (!hasLocationChange && hasLocationChangeBundle)
                hasLocationChange = true;

            newItem.children = newChildren;
        }

        arr.push(newItem);
    });

    return {
        newItems: arr,
        hasLocationChange,
        hasTaxChange,
    };
};
